var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content"},[_c('Nav'),_c('HotPush',{attrs:{"list":_vm.list}}),_c('LeftMenu',{attrs:{"brandList":_vm.list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }